import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { GlobalStyles } from '@mui/material';

// Global styles for the body
export const OtpGlobalStyles = () => (
  <GlobalStyles
    styles={(theme) => ({
      body: {
        backgroundColor: theme.palette.background.default,
      },
    })}
  />
);

// Styled components approach
export const ModalContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[5],
  padding: theme.spacing(2, 4, 3),
}));

// For backward compatibility with the makeStyles approach
const useStyles = () => ({
  modalStyle: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    backgroundColor: '#fff',
    boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 5px 8px 0px rgba(0,0,0,0.14), 0px 1px 14px 0px rgba(0,0,0,0.12)',
    padding: '16px 32px 24px',
  },
});

export default useStyles;